import type { CarrierPrice } from "~/shared/schemas/carrier-schema.ts";

/**
 * Returns the carrier's effective maximum liability. A manual override takes
 * precedence when present; otherwise the value is based on the quote's
 * insurance product type (2 = Used, anything else defaults to New).
 */
export const getEffectiveCarrierLiability = (
	carrierPrice: CarrierPrice,
	productTypeId: number | null | undefined,
): number => {
	if (
		carrierPrice.maxLiabilityOverride &&
		carrierPrice.maxLiabilityOverride > 0
	) {
		return carrierPrice.maxLiabilityOverride;
	}
	return productTypeId === 2
		? carrierPrice.maxLiabilityUsed
		: carrierPrice.maxLiabilityNew;
};

/**
 * Mirrors the Shipment Value modal logic: a carrier's liability is insufficient
 * when no insurance is applied to the quote and the shipment value exceeds the
 * carrier's effective maximum liability.
 */
export const carrierLiabilityIsInsufficient = (
	carrierPrice: CarrierPrice,
	shipmentValue: number | null,
	insuranceApplyTypeId: number | null,
	insuranceProductTypeId: number | null,
): boolean => {
	if (insuranceApplyTypeId != null) return false;
	if (shipmentValue == null || shipmentValue <= 0) return false;
	return (
		shipmentValue >
		getEffectiveCarrierLiability(carrierPrice, insuranceProductTypeId)
	);
};
